class CheckoutExpiredItemsWarning extends React.Component {

    render() {
        var self = this;

        if (!this.props.expiredItemsInCart)
            return null;

        return (
            <div className='checkout-completed'>

                <div className='checkout-biotrack__title'>
                    Expired items in cart
                </div>

                <div className='checkout-overdue__txt'>
                    Do you wish to continue?
                </div>

                <div className='row' style={{margin:0}}>
                    <div
                        className='checkout-overdue__btn checkout-overdue__no'
                        onClick={() => { this.props.onCancel(); }}>

                        No
                    </div>

                    <div
                        className='checkout-overdue__btn checkout-overdue__yes'
                        onClick={() => { this.props.onConfirm(); }}>

                        Yes
                    </div>
                </div>
            </div>
        );
    }
}

export default CheckoutExpiredItemsWarning;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/CheckoutExpiredItemsWarning.react.jsx